import type { ExportColumnKeys } from "@/modules/export";
import type { EmbarcacoesColumnKey } from "./embarcacoes.types";

/** Coluna da tela de Embarcações → chave do core na exportação (`null`: fora do arquivo). */
export const EMBARCACOES_EXPORT_COLUMN_KEYS: ExportColumnKeys<EmbarcacoesColumnKey> = {
  acronimo: "acronimo",
  nome: "embarcacao",
  tipo: "tipo",
  situacao: "situacao",
  acoes: null,
};
